import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVerticalVideosGenres, verticalVideosGenreFacetsSelector } from '../../../VerticalVideosPage/VerticalVideosPage.duck';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../../../util/routes';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { LISTING_SEARCH_ID, PRIMARY_GENRE_FILTER } from '../../../../constants';
import { LIVE_EVENT_PRODUCTS } from '../../../../util/types';
import { HorizontalItemsSlider } from '../../../../components';

const VerticalVideosGenre = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const routeConfiguration = useRouteConfiguration();
    const genreFacets = useSelector(verticalVideosGenreFacetsSelector);

    useEffect(() => {
        dispatch(fetchVerticalVideosGenres());
    }, [dispatch]);

    const handleGenreClick = (genre) => {
        history.push(
            createResourceLocatorString(
                'SearchPage',
                routeConfiguration,
                { searchId: LISTING_SEARCH_ID },
                { [PRIMARY_GENRE_FILTER]: genre, 'publicData.orientation': 'vertical' }
            )
        );
    };

    return (
        <HorizontalItemsSlider items={genreFacets || []} onClick={(item) => handleGenreClick(item)} />
    );
};

export default VerticalVideosGenre;
